/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityCvssMetric {
    getFixupPrototypeFunction() { return AppSecopsVulnerabilityCvssMetric.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityCvssMetric>): AppSecopsVulnerabilityCvssMetric {
        let obj = Object.assign(new AppSecopsVulnerabilityCvssMetric(), model);
        AppSecopsVulnerabilityCvssMetric.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityCvssMetric>): AppSecopsVulnerabilityCvssMetric {
        if (!model) return null;
        return AppSecopsVulnerabilityCvssMetric.newInstance(<AppSecopsVulnerabilityCvssMetric> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityCvssMetric) {
        if (!obj) return;

        models.AppSecopsVulnerabilityCvssMetric.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityCvssMetric): boolean {
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityCvssMetric.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.base_score === undefined) {
            this.base_score = 0;
        }
    }

    /**
     * CVSS version used for scoring (e.g., 3.1)
     */
    version: string;

    /**
     * Encoded CVSS vector string representing all metric values
     */
    vector_string: string;

    /**
     * Level of complexity required for an attacker to exploit the vulnerability
     */
    access_complexity: string;

    /**
     * Encoded access vector string representing all metric values
     */
    access_vector: string;

    /**
     * Context required to exploit the vulnerability (e.g., network, local)
     */
    attack_vector: string;

    /**
     * Specific conditions or requirements needed for a successful attack (e.g., configuration, user privileges)
     */
    attack_requirements: string;

    /**
     * Authentication type (e.g., Basic authentication)
     */
    authentication: string;

    /**
     * Level of difficulty to exploit the vulnerability
     */
    attack_complexity: string;

    /**
     * Indicates a vulnerability is to be exploited based on exploit availability and threat intelligence.
     */
    exploit_maturity: string;

    /**
     * Level of privileges an attacker needs to exploit the vulnerability
     */
    privileges_required: string;

    /**
     * Indicates if user interaction is required for exploitation
     */
    user_interaction: string;

    /**
     * Whether exploitation affects resources beyond the vulnerable component
     */
    scope: string;

    /**
     * Impact on confidentiality if the vulnerability is exploited
     */
    confidentiality_impact: string;

    /**
     * Impact on data integrity if the vulnerability is exploited
     */
    integrity_impact: string;

    /**
     * Impact on system availability if the vulnerability is exploited
     */
    availability_impact: string;

    /**
     * CVSS base score (0–10) indicating overall severity
     */
    base_score: number;

    /**
     * Severity level of the vulnerability
     */
    severity: models.Severity;

    /**
     * Availability impact on dependent or downstream systems after the vulnerability is exploited
     */
    subsequent_availability: string;

    /**
     * Impact on confidentiality of the system after the vulnerability is exploited
     */
    subsequent_confidentiality: string;

    /**
     * Integrity impact on systems that depend on or are affected by the vulnerable system.
     */
    subsequent_integrity: string;

    /**
     * Availability impact on the directly affected system after the vulnerability is exploited.
     */
    vulnerable_availability: string;

    /**
     * Confidentiality impact on the directly affected system after the vulnerability is exploited.
     */
    vulnerable_confidentiality: string;

    /**
     * Integrity impact on the system where the vulnerability exists
     */
    vulnerable_integrity: string;

}
